<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("ventasPorClientes")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">

                        <div class="col-md-3">
                            <div class="form-group">
                                <label>{{$t("companya")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idCompany"
                                           filterable
                                           @change="getBusiness()"
                                           :placeholder="$t('seleccionaCompania')">
                                    <el-option v-for="c in listCompany"
                                               class="select-primary"
                                               :value="c.id"
                                               :label="c.name"
                                               :key="c.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change="getSalesProducts()">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="$t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="$t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>&nbsp;</label>
                                <button class="btn btn-primary" @click="getSalesProducts()" style="width: 100%">
                                    <img src="static/img/sync.gif" alt="" v-if="loading" width="15">
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <div class="col-md-12" v-else-if="respuesta">
                <template v-if="list.length>0">
                    <div class="row justify-content-between div-export">

                        <div class="col-md-2 col-xs-12">
                            <el-dropdown>
                                <el-button type="primary" size="small">
                                    <i class="fa fa-file"></i>
                                    {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <a :href="urlExportPDF">
                                        <el-dropdown-item class="text-danger">
                                            <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                    <a :href="urlExportExcel">
                                        <el-dropdown-item class="text-success">
                                            <strong>
                                                <i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                </el-dropdown-menu>
                            </el-dropdown>

                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-bordered table-striped text-nowrap">
                            <thead class="thead-dark">
                            <tr>
                                <th v-if="ordenarCliente===0" @click="sortedArrayNameASC('name')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t("cliente")}}
                                </th>
                                <th v-else @click="sortedArrayNameDESC('name')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("cliente")}}
                                </th>

                                <th v-if="ordenarImporte===0" @click="sortedArrayImporteASC('amount')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t("importe")}}
                                </th>
                                <th v-else @click="sortedArrayImporteDESC('amount')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("importe")}}
                                </th>
                                <th v-if="ordenarImporteIva===0" @click="sortedArrayImporteIvaASC('amount')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t("importe")}} sin IVA
                                </th>
                                <th v-else @click="sortedArrayImporteIvaDESC('amount')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("importe")}} sin IVA
                                </th>
                                <th v-if="ordenarConsumiciones===0" @click="sortedArrayConsumicionesASC('units')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t('tickets')}}
                                </th>
                                <th v-else @click="sortedArrayConsumicionesDESC('units')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t('tickets')}}
                                </th>
                                <th v-if="ordenarComensales===0" @click="sortedArrayComensalesASC('units')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t('comensales')}}
                                </th>
                                <th v-else @click="sortedArrayComensalesDESC('units')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t('comensales')}}
                                </th>

                                <th v-if="ordenarMedio===0" @click="sortedArrayMedioASC('amount/units')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t("media")}}
                                </th>

                                <th v-else @click="sortedArrayMedioDESC('amount/units')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("media")}}
                                </th>

                                <th v-if="ordenarImporteTotal===0" @click="sortedArrayImporteTotalASC('totalAmount')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t("importeSinDescuento")}}
                                </th>

                                <th v-else @click="sortedArrayImporteTotalDESC('totalAmount')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("importeSinDescuento")}}
                                </th>

                                <th v-if="ordenarImporteTotalIva===0" @click="sortedArrayImporteTotalIvaASC('totalAmountWithoutIVA')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t("importeSinDescuento")}} sin IVA 
                                </th>

                                <th v-else @click="sortedArrayImporteTotalIvaDESC('totalAmountWithoutIVA')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("importeSinDescuento")}} sin IVA 
                                </th>

                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="obj in list">
                                <td>{{obj.name +' ' +obj.surName}}</td>
                                <td align="right">{{obj.amount | currency}}</td>
                                <td align="right">{{obj.amountWithoutIVA | currency}}</td>
                                <td align="right">{{obj.units}}</td>
                                <td align="right">{{obj.comensales}}</td>
                                <td align="right">{{obj.amount / obj.units | currency}}</td>
                                <td align="right">{{obj.totalAmount | currency}}</td>
                                <td align="right">{{obj.totalAmountWithoutIVA | currency}}</td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr class="table-success">
                                <td><strong>{{$t("total")}}</strong></td>
                                <td class="text-right"><strong>{{getTotalPrecio | currency}}</strong></td>
                                <td class="text-right"><strong>{{getTotalPrecioSinIVA | currency}}</strong></td>
                                <td class="text-right"><strong>{{getTotalConsumiciones}}</strong></td>
                                <td class="text-right"><strong>{{getTotalComensales}}</strong></td>
                                <td class="text-right"><strong>{{getTotalPrecio/getTotalConsumiciones | currency}}</strong></td>
                                <td class="text-right"><strong>{{getTotalPrecioCompleto | currency}}</strong></td>
                                <td class="text-right"><strong>{{getTotalPrecioCompletoSinIVA | currency}}</strong></td>

                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </template>
                <template v-else>
                    <div class="alert alert-danger" role="alert">
                        {{$t("noHay")}} <strong>{{$t("ventasPorClientes")}}</strong> {{$t("rangoDeFechas")}}
                    </div>
                </template>
            </div>

        </div>
    </div>

</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    import Chart from 'chart.js';
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    import { mapState } from 'vuex'

    export default {
        created() {
            this.$store.dispatch("setNameRoute", this.$i18n.t("ventasPorClientes"));
            this.getCompanies();

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;
            }

        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        data() {
            return {
                loading: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                listBusinesses: [],
                idBusiness: 0,
                list: [],
                mode: 0,
                contador: 0,
                chartIn: 0,
                listCompany: [],
                idCompany: 0,

                ordenarInvitations: 0,
                ordenarConsumiciones: 0,
                ordenarComensales: 0,
                ordenarImporte: 0,
                ordenarImporteIva: 0,
                ordenarCliente: 0,
                ordenarMedio: 0,
                ordenarImporteTotal: 0,
                ordenarImporteTotalIva: 0,
                

                respuesta: true,
            }
        },
        computed: {
            ...mapState(["permiso"]),
            urlExportPDF() {
                // return "../api/public/index.php/clients/exportSalesByClients/PDF?idBusiness=" + this.idBusiness + "&idCompany=" + this.idCompany + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
   
                return this.$store.getters.apiUrl+"/clients/exportSalesByClients/PDF?idBusiness=" + this.idBusiness + "&idCompany=" + this.idCompany + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },
            urlExportExcel() {
                // return "../api/public/index.php/clients/exportSalesByClients/Excel?idBusiness=" + this.idBusiness + "&idCompany=" + this.idCompany + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
 
                return this.$store.getters.apiUrl+"/clients/exportSalesByClients/Excel?idBusiness=" + this.idBusiness + "&idCompany=" + this.idCompany + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },

            getTotalPrecio() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.amount;
                });
                return total;
            },
            getTotalPrecioSinIVA() {
                let total = 0;
                this.list.forEach(function (d) {
                    total += d.amountWithoutIVA;
                })
                return total;
            },
            getTotalPrecioCompleto() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.totalAmount;
                });
                return total;
            },
            getTotalPrecioCompletoSinIVA() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.totalAmountWithoutIVA;
                });
                return total;
            },
            getTotalConsumiciones() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.units;
                });
                return total;
            },
            getTotalComensales() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += parseInt(d.comensales);
                });
                return total;
            },

            getTotalMedia() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.amount / d.units;
                });
                return total;
            }
        },
        methods: {


            sortedArrayNameASC: function () {
                this.ordenarCliente = 1;

                function compare(a, b) {
                    if (a.name.toUpperCase() < b.name.toUpperCase())
                        return -1;
                    if (a.name.toUpperCase() > b.name.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayNameDESC: function () {
                this.ordenarCliente = 0;

                function compare(a, b) {

                    if (a.name.toUpperCase() > b.name.toUpperCase())
                        return -1;
                    if (a.name.toUpperCase() < b.name.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteASC: function () {
                this.ordenarImporte = 1;

                function compare(a, b) {
                    if (a.amount < b.amount)
                        return -1;
                    if (a.amount > b.amount)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteDESC: function () {
                this.ordenarImporte = 0;

                function compare(a, b) {

                    if (a.amount > b.amount)
                        return -1;
                    if (a.amount < b.amount)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteTotalASC: function () {
                this.ordenarImporteTotal = 1;

                function compare(a, b) {
                    if (a.totalAmount < b.totalAmount)
                        return -1;
                    if (a.totalAmount > b.totalAmount)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteTotalDESC: function () {
                this.ordenarImporteTotal = 0;

                function compare(a, b) {

                    if (a.totalAmount > b.totalAmount)
                        return -1;
                    if (a.totalAmount < b.totalAmount)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteIvaASC: function () {
                this.ordenarImporteIva = 1;

                function compare(a, b) {
                    if (a.amountWithoutIVA < b.amountWithoutIVA)
                        return -1;
                    if (a.amountWithoutIVA > b.amountWithoutIVA)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteIvaDESC: function () {
                this.ordenarImporteIva = 0;

                function compare(a, b) {

                    if (a.amountWithoutIVA > b.amountWithoutIVA)
                        return -1;
                    if (a.amountWithoutIVA < b.amountWithoutIVA)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteTotalIvaASC: function () {
                this.ordenarImporteTotalIva = 1;

                function compare(a, b) {
                    if (a.totalAmountWithoutIVA < b.totalAmountWithoutIVA)
                        return -1;
                    if (a.totalAmountWithoutIVA > b.totalAmountWithoutIVA)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteTotalIvaDESC: function () {
                this.ordenarImporteTotalIva = 0;

                function compare(a, b) {

                    if (a.totalAmountWithoutIVA > b.totalAmountWithoutIVA)
                        return -1;
                    if (a.totalAmountWithoutIVA < b.totalAmountWithoutIVA)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayConsumicionesASC: function () {
                this.ordenarConsumiciones = 1;

                function compare(a, b) {
                    if (a.units < b.units)
                        return -1;
                    if (a.units > b.units)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayConsumicionesDESC: function () {
                this.ordenarConsumiciones = 0;

                function compare(a, b) {

                    if (a.units > b.units)
                        return -1;
                    if (a.units < b.units)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayComensalesASC: function () {
                this.ordenarComensales = 1;

                function compare(a, b) {
                    if (a.comensales < b.comensales)
                        return -1;
                    if (a.comensales > b.comensales)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayComensalesDESC: function () {
                this.ordenarComensales = 0;

                function compare(a, b) {

                    if (a.comensales > b.comensales)
                        return -1;
                    if (a.comensales < b.comensales)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayMedioASC: function () {
                this.ordenarMedio = 1;

                function compare(a, b) {
                    if (a.amount / a.units < b.amount / b.units)
                        return -1;
                    if (a.amount / a.units > b.amount / b.units)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayMedioDESC: function () {
                this.ordenarMedio = 0;

                function compare(a, b) {

                    if (a.amount / a.units > b.amount / b.units)
                        return -1;
                    if (a.amount / a.units < b.amount / b.units)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },

            getCompanies() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getCompaniesByUser", config)
                    .then(function (response) {

                        if (!vm.idCompany) {
                            vm.idCompany = response.data.result[0].id;
                        }
                        vm.listCompany = response.data.result;

                        vm.getBusiness()

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getBusiness() {
                var config = {
                    params: {
                        idCompany: this.idCompany,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByCompany", config)
                    .then(function (response) {

                        vm.listBusinesses = [];

                        if (response.data.result.length > 0) {


                            let xDate = {

                                checked: false,
                                establishmentName: vm.$t('todos'),
                                id: 0
                            };
                            vm.listBusinesses.push(xDate);
                        }


                        for (let i = 0; i < response.data.result.length; i++) {

                            let xDate = {

                                checked: response.data.result[i].checked,
                                establishmentName: response.data.result[i].establishmentName,
                                id: response.data.result[i].id
                            };

                            vm.listBusinesses.push(xDate);

                        }

                        vm.getSalesProducts();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getSalesProducts() {

                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    } else {
                        this.loading = true;

                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                idCompany: this.idCompany,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.axios.get(this.$store.getters.apiUrl + "clients/getVentasByClients", config)
                            .then(function (response) {
                                if (response.data.response) {
                                    vm.list = response.data.result;
                                    vm.respuesta = true;
                                }else if (response.data.response == false && response.data.rangoMayor == true) {
                                    swal({
                                    title: "Lo sentimos",
                                    text: response.data.result,
                                    confirmButtonClass: "btn btn-info btn-fill",
                                    type: "info",
                                    });
                                    vm.respuesta = false;
                                }
                                else {
                                    swal({
                                        title: vm.$t('atencion'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });
                                    vm.respuesta = false;

                                }
                                vm.loading = false;

                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }
            }

        }
    }
</script>

<style scoped>


    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Clientes/VentasClientes.vue